function calcularDigitoVerificador(cuerpo) {
  let suma = 0
  let multiplo = 2

  for (let indice = cuerpo.length - 1; indice >= 0; indice -= 1) {
    suma += Number.parseInt(cuerpo[indice], 10) * multiplo
    multiplo = multiplo === 7 ? 2 : multiplo + 1
  }

  const resto = 11 - (suma % 11)

  if (resto === 11) return '0'
  if (resto === 10) return 'K'

  return String(resto)
}

export function limpiarRut(rut) {
  if (!rut) return ''

  return rut
    .toString()
    .trim()
    .toUpperCase()
    .replace(/[.\s-]/g, '')
}

export function formatearRut(rut) {
  const limpio = limpiarRut(rut)

  if (limpio.length < 2) return limpio

  const cuerpo = limpio.slice(0, -1)
  const digitoVerificador = limpio.slice(-1)

  const cuerpoFormateado = cuerpo.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    '.'
  )

  return `${cuerpoFormateado}-${digitoVerificador}`
}

export function normalizarRut(rut) {
  const limpio = limpiarRut(rut)

  if (limpio.length < 2) return limpio

  const cuerpo = limpio.slice(0, -1)
  const digitoVerificador = limpio.slice(-1)

  return `${cuerpo}-${digitoVerificador}`
}

export function validarRut(rut) {
  if (rut === null || rut === undefined) return true

  const bruto = rut.toString().trim()

  if (!bruto) return true

  const limpio = limpiarRut(bruto)

  if (limpio.length < 2) return false

  const cuerpo = limpio.slice(0, -1)
  const digitoVerificador = limpio.slice(-1)

  if (!/^\d+$/.test(cuerpo)) return false
  if (!/^[0-9K]$/.test(digitoVerificador)) return false

  return calcularDigitoVerificador(cuerpo) === digitoVerificador
}
